import React from 'react';
import { MdInfo, MdClose, MdCheck, MdShare } from 'react-icons/md';
import { BadgeIcon, badgeHowToEarn } from './badgeData';

export function BadgeInfoModal({ badge, onClose, onShare }) {
  if (!badge) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-xl" onClick={e => e.stopPropagation()}>
        <div className="flex justify-between items-start mb-4">
          <div className="flex items-center gap-3">
            <div 
              className="w-14 h-14 rounded-full flex items-center justify-center"
              style={{ backgroundColor: badge.color + '20' }}
            >
              <BadgeIcon icon={badge.icon} color={badge.color} size={32} earned={badge.earned} />
            </div>
            <div>
              <h4 className="text-lg font-bold text-gray-800 font-rubik">{badge.name}</h4>
              <p className="text-sm text-gray-500 font-rubik">{badge.earned ? 'Earned' : 'Locked'}</p>
            </div>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full transition-colors">
            <MdClose className="text-gray-400 text-xl" />
          </button>
        </div>
        
        {badge.earned ? (
          <div className="bg-green-50 rounded-xl p-4 mb-4">
            <p className="text-sm font-medium text-green-800 font-rubik flex items-start gap-2">
              <MdCheck className="text-green-500 text-lg flex-shrink-0 mt-0.5" />
              <span>Congratulations! You've earned this achievement.</span>
            </p>
          </div>
        ) : (
          <div className="bg-blue-50 rounded-xl p-4 mb-4">
            <p className="text-sm font-medium text-blue-800 font-rubik flex items-start gap-2">
              <MdInfo className="text-blue-500 text-lg flex-shrink-0 mt-0.5" />
              <span><strong>How to earn:</strong> {badgeHowToEarn[badge.id] || badgeHowToEarn['default']}</span>
            </p>
          </div>
        )}

        {badge.description && (
          <p className="text-sm text-gray-600 font-rubik">{badge.description}</p>
        )}

        {badge.earned && onShare && (
          <button
            onClick={(e) => { onClose(); onShare(badge, e); }}
            className="w-full mt-4 py-2 px-4 bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-xl font-medium hover:from-blue-600 hover:to-indigo-600 transition-all flex items-center justify-center gap-2"
            data-testid="badge-info-share-btn"
          >
            <MdShare className="text-lg" />
            Share Achievement
          </button>
        )}
      </div>
    </div>
  );
}
